import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-100 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 mt-auto">
      <div className="container mx-auto px-6 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
          {/* Company Info */}
          <div>
            <h3 className="font-bold text-lg mb-3">CashX</h3>
            <p className="text-sm text-muted-foreground">
              Modernes POS-System für die Gastronomie.
              DSGVO-konform. Made in Germany.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold mb-3">Produkt</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://cash-x.de/features" className="text-muted-foreground hover:text-foreground transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="https://cash-x.de/pricing" className="text-muted-foreground hover:text-foreground transition-colors">
                  Preise
                </a>
              </li>
              <li>
                <a href="https://cash-x.de/demo" className="text-muted-foreground hover:text-foreground transition-colors">
                  Demo anfragen
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-3">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:support@cash-x.de" className="text-muted-foreground hover:text-foreground transition-colors">
                  support@cash-x.de
                </a>
              </li>
              <li>
                <a href="https://docs.cash-x.de" className="text-muted-foreground hover:text-foreground transition-colors">
                  Dokumentation
                </a>
              </li>
              <li>
                <a href="https://status.cash-x.de" className="text-muted-foreground hover:text-foreground transition-colors">
                  System-Status
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3">Rechtliches</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="text-muted-foreground hover:text-foreground transition-colors">
                  AGB
                </Link>
              </li>
              <li>
                <Link to="/legal/dpa" className="text-muted-foreground hover:text-foreground transition-colors">
                  AVV / DPA
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" className="text-muted-foreground hover:text-foreground transition-colors">
                  Cookie-Richtlinie
                </Link>
              </li>
              <li>
                <Link to="/legal/imprint" className="text-muted-foreground hover:text-foreground transition-colors">
                  Impressum
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-6" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground">
          <div>
            © {currentYear} CashX. Alle Rechte vorbehalten.
          </div>
          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="/legal/privacy" className="hover:text-foreground transition-colors">
              Datenschutz
            </Link>
            <span>·</span>
            <Link to="/legal/terms" className="hover:text-foreground transition-colors">
              AGB
            </Link>
            <span>·</span>
            <Link to="/legal/imprint" className="hover:text-foreground transition-colors">
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
